import type { EditorHost } from '@blocksuite/hive/std';

import {
  HIVE_AI_PANEL_WIDGET,
  HiveAIPanelWidget,
} from '../widgets/ai-panel/ai-panel';

export const getAIPanelWidget = (host: EditorHost): HiveAIPanelWidget => {
  const rootBlockId = host.doc.root?.id;
  if (!rootBlockId) {
    throw new Error('rootBlockId is not found');
  }
  const aiPanel = host.view.getWidget(HIVE_AI_PANEL_WIDGET, rootBlockId);
  if (!(aiPanel instanceof HiveAIPanelWidget)) {
    throw new Error('AI panel not found');
  }
  return aiPanel;
};
